var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-chart" },
    [
      _vm.showIntervalArrows && _vm.showLeftArrow
        ? _c(
            "div",
            {
              staticClass: "chart-arrow left",
              on: {
                click: function($event) {
                  return _vm.getDataInInterval(true)
                }
              }
            },
            [
              _c("b-icon-caret-left"),
              _c("span", [_vm._v(_vm._s(_vm.$t("chart.lessRecent")))])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("highcharts", { attrs: { options: _vm.chartOptions } }),
      _vm._v(" "),
      _vm.showIntervalArrows && _vm.showRightArrow
        ? _c(
            "div",
            {
              staticClass: "chart-arrow right",
              on: {
                click: function($event) {
                  return _vm.getDataInInterval(false)
                }
              }
            },
            [
              _vm._v(_vm._s(_vm.$t("chart.moreRecent"))),
              _c("b-icon-caret-right"),
              _c("span")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-acb13de0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acb13de0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/Chart.vue
// module id = 2626
// module chunks = 28 32 34 37 38 141